import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {OwsClientService, OwsServiceErrorResponse} from 'ows-library';
import {Router} from '@angular/router';
import {AuthorizationServicesEnum} from 'ows-library';
import { RequestsService } from 'app/compartilhado/servicos/requests.service';
import { PopUpService } from 'app/compartilhado/componentes/pop-up/pop-up.service';

@Injectable()

export class VisualizarImagemOriginalService {
  fotoOriginalChanged = new Subject<any>();

  constructor(private owsClientService: OwsClientService,
              private requestsService: RequestsService,
              private router: Router,
              private popUpService: PopUpService) {
  }

  obterLaudo(imagemId: string, shortId: string) {
    this.owsClientService.get<any>('administrativo/laudos/fotooriginal', {
      authorizationService: AuthorizationServicesEnum.None,
      requestParameters: [{key: 'imagemId', value: imagemId},
        {key: 'shortId', value: shortId}]
    }).subscribe((response) => {
        this.fotoOriginalChanged.next(response.body);
      },
      error => {
        if (error instanceof Error) {
          this.popUpService.showCustomPopWarning('Erro de conexão', error.message);
        } else if (!error.error) {
          this.popUpService.showCustomPopWarning('Falha na operação do registro.', 'Não foi possível estabelecer conexão com a API.')
        } else {
          this.popUpService.showCustomPopWarning('Falha na operação do registro', (<OwsServiceErrorResponse>error).error.Code + ': ' + (<OwsServiceErrorResponse>error).error.Message);
        }
      });
  }
}
